import { createDebugger } from '@iotize/common/debug';

const prefix = '@iotize-private/tap-server';

export const debug = createDebugger(prefix);
